import styles from './ExternalCheckoutView.module.css'

interface ExternalCheckoutViewProps {
  error: boolean
}

export function ExternalCheckoutView({ error }: ExternalCheckoutViewProps) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {error ? (
          <>
            <h1 className={styles.title}>Something went wrong</h1>
            <p className={styles.description}>
              We were unable to redirect you to the checkout page. Please try
              again later.
            </p>
          </>
        ) : (
          <>
            <h1 className={styles.title}>Checkout</h1>
            <p className={styles.description}>
              We're redirecting you to your checkout page.
            </p>
          </>
        )}
      </div>
    </div>
  )
}
